/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/theater/showtimes/openChainFilterDesktop.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'theater/showtimes/openChainFilterDesktop', exports: {} };
const exports = module.exports;



import $ from '@take-2/fd-modules/jQuery';



import { Fandango as Fandango_context } from '@take-2/fd-modules/splits/require-core';

const { context } = Fandango_context;


import chainListOverlay from '@take-2/fd-modules/theater/showtimes/chainListOverlay';



const { chainID } = readPageContext(context)


const Selectors = {
    FILTER_HELP: '#help-tip-open-chain-filter',
    OPEN_CHAIN_FILTER_BTN: '#open-chain-filter-popup-btn',
    OPEN_CHAIN_FILTER_BTN_ICON: '#open-chain-filter-popup-btn-icon',
}


const Styles = {
    ACTIVE_FILTER: 'open-chain-filter__filter-btn--active',
    DOWN_ARROW_BLUE: 'icon-arrow-down-blue',
    DOWN_ARROW_WHITE: 'icon-arrow-down-white',
    HELP_TIP: 'tsp__help-tip',
    UP_ARROW_BLUE: 'icon-arrow-up-blue',
    UP_ARROW_WHITE: 'icon-arrow-up-white',
}
function readPageContext(context) {
    return {
        chainID: context.theater.chainID
    };
}
function updateDropdownIcon(opts) {
    const $icon = $(Selectors.OPEN_CHAIN_FILTER_BTN_ICON);
    $icon
        .removeClass(Styles.DOWN_ARROW_BLUE)
        .removeClass(Styles.DOWN_ARROW_WHITE)
        .removeClass(Styles.UP_ARROW_BLUE)
        .removeClass(Styles.UP_ARROW_WHITE);
    let icon;
    if (opts.open) {
        icon = opts.selected ? Styles.UP_ARROW_WHITE : Styles.UP_ARROW_BLUE;
    }
    else {
        icon = opts.selected ? Styles.DOWN_ARROW_WHITE : Styles.DOWN_ARROW_BLUE;
    }
    $icon.addClass(icon);
}
function onOverlayClose() {
    const selectedChain = chainID;
    $(Selectors.OPEN_CHAIN_FILTER_BTN).toggleClass(Styles.ACTIVE_FILTER, !!selectedChain);
    updateDropdownIcon({ open: false, selected: !!selectedChain });
}
function onClick() {
    $(this).addClass(Styles.ACTIVE_FILTER);
    updateDropdownIcon({ open: true, selected: true });
    chainListOverlay.show();
}
function init() {
    $(Selectors.OPEN_CHAIN_FILTER_BTN).click(onClick);
}
export default {
    init,
    onOverlayClose
};
